export default __webpack_public_path__ + "static/media/i112hp.8468e835.webp";